import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-one-columns-four-page',
  templateUrl: './courses-grid-style-one-columns-four-page.component.html',
  styleUrls: ['./courses-grid-style-one-columns-four-page.component.scss']
})
export class CoursesGridStyleOneColumnsFourPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
